import React from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash';
import { compose } from 'redux'
import { connect } from 'react-redux';
import { createUseStyles } from 'react-jss';
import DetailsHeader from '../OffersDetails/DetailsHeader/DetailsHeader'
import { truncateText } from '../../helpers/utils';
import MotoPhoto from '../MotoPhoto/MotoPhoto';
import Gallery from '../Gallery/Gallery';
import PickupZipcode from '../OffersDetails/PickupZipcode/PickupZipcode';
import withScopedTranslations from '../../withScopedTranslations/withScopedTranslations';
import VehicleDetailsGeneral from '../molecules/VehicleDetailsGeneral';

import DetailsDescription from '../OffersDetails/DetailsDescription/DetailsDescription';
import { styles } from '../AuctionForm/formStyles';

const MotorbikeDetails = ({ details, t, isMobile, whichFolder, }) => {
  const createdAt = (() => {
    switch (whichFolder) {
      case 'browse':
        return get(details, 'published_at');
      case 'my_bets':
        return get(details, 'updated_at');
      case 'new_bets':
        return get(details, 'updated_at');
      case 'in_realization':
        return get(details, ['details', 'contact_details', 'updated_at']);
      default:
        return null;
    }
  });

  const photos = get(details, 'photos') || [];
  const classes = useStyles()
  if (!Object.keys(details).length) {
    return null
  }

  return (
    <div className={classes.detailsLeftColumn}>
      <div className={classes.row}>
        <DetailsHeader
          score={get(details, ['vehicle', 'score'])}
          details={[
            truncateText(get(details, ['vehicle', 'brand', 'name']), 12, 'right'),
            get(details, ['vehicle', 'model']),
            get(details, ['vehicle', 'year']),
            get(details, 'hash_id'),
            createdAt()
          ]}
        />
      </div>
      <MotoPhoto
        generalConditionScore={get(details, ['vehicle', 'general_condition_note'])}
        tiresScore={get(details, ['vehicle', 'tires_note'])}
        consumablesConditionScore={get(details, ['vehicle', 'consumables_condition_note'])}
      />
      <Gallery photos={photos} />
      <PickupZipcode
        translations={t('pickup_zipcode')}
        zipCode={get(details, 'zip_code')}
        pickUp={get(details, 'place')}
        countryCode={get(details, 'country_code')}
      />


      {!isMobile &&
        <VehicleDetailsGeneral
          fields={[
            { key: 'accident_free', value: details.vehicle.accident_free,  positiveValues: [true], },
            { key: 'not_wrecked', value: details.vehicle.not_wrecked,  positiveValues: [true], },
            { key: 'original_lacquer', value: details.vehicle.original_lacquer,  positiveValues: [true], },
            { key: 'import_vehicle', value: details.vehicle.import_vehicle, positiveValues: [false], },
            { key: 'vin', value: details.vehicle.vin, positiveValues: [true], },
            { key: 'rental', value: details.vehicle.rental, positiveValues: [false], },
            { key: 'financed_vehicle', value: details.financed_vehicle, positiveValues: [false], },
            { key: 'service_booklet', value: details.vehicle.service_booklet, positiveValues: ['existing', 'run',  'digitally_run'], },
            { key: 'abs', value: details.vehicle.abs, positiveValues: [true], },
            { key: 'defects', value: details.vehicle.defects, positiveValues: [false], }
          ]}
        />
      }

      <DetailsDescription
        fields={[
          { icon: 'defects_description', categoryName: t('details_description.defects_description'),
            description: get(details, ['vehicle', 'defects_description']), iconColor: styles.colors.red, },
          { icon: 'accessories_description', categoryName: t('details_description.accessories_description'),
            description: get(details, ['vehicle', 'accessories_description']), },
          { icon: 'rental_description', categoryName: t('details_description.rental_description'),
            description: get(details, ['vehicle', 'rental_description']) && t(`details_description.rental_description_options.${get(details, ['vehicle', 'rental_description'])}`), },
          { icon: 'import_description', categoryName: t('details_description.import_description'),
            description: get(details, ['vehicle', 'import_description']) && t(`details_description.import_description_options.${get(details, ['vehicle', 'import_description'])}`), },
          get(details, 'comments')?.length
            ? { icon: 'comments', categoryName: t('details_description.comments'),
                description: get(details, 'comments'), }
            : null
        ].filter(Boolean)}
      />
    </div>
  )
}

const mapStateToProps = (state) => {
  const details = get(state, ['offerDetails', 'data']);
  return {
    isMobile: get(state, ['layout', 'isMobile']),
    details,
  };
};

const useStyles = createUseStyles({
  detailsLeftColumn: {
    paddingLeft: '15px !important',
    paddingRight: '15px !important',
    width: '58.33333333%',
    float: 'left',
  },
  row: {
    display: 'flex',
  },
  '@media(max-width: 900px)': {
    detailsLeftColumn: {
      width: '100%',
    },
  },
})

MotorbikeDetails.propTypes = {
  whichFolder: PropTypes.string.isRequired,
  isMobile: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
  details: PropTypes.shape({
    photos: PropTypes.arrayOf(PropTypes.shape({
        file: PropTypes.shape({
          url: PropTypes.string,
        }),
      })),
    general_condition_note: PropTypes.number,
    vehicle: PropTypes.shape({
      defects: PropTypes.bool,
      accident_free: PropTypes.bool,
      rental: PropTypes.bool,
      service_booklet: PropTypes.string,
      not_wrecked: PropTypes.bool,
      original_lacquer: PropTypes.bool,
      import_vehicle: PropTypes.bool,
      vin: PropTypes.string,
      abs: PropTypes.bool,
    }),
    tires_note: PropTypes.number,
    total_mileage_note: PropTypes.number,
    number_of_owners_previous_note: PropTypes.number,
    last_inspection_note: PropTypes.number,
    hash_id: PropTypes.string,
    model: PropTypes.string,
    year: PropTypes.string,
    number_of_previous_owners: PropTypes.string,
    general_condition: PropTypes.string,
    tires: PropTypes.string,
    score: PropTypes.number,
    total_mileage: PropTypes.number,
    last_inspection: PropTypes.string,
    zip_code: PropTypes.string,
    place: PropTypes.string,
    accessories: PropTypes.bool,
    financed_vehicle: PropTypes.bool,
    messages: PropTypes.string,
    my_bet: PropTypes.number,
    made_bet: PropTypes.string,
    bet: PropTypes.number,
    defects_description: PropTypes.string,
    accessories_description: PropTypes.string,
    brand: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    }),
  }).isRequired,
}

export default compose(
  withScopedTranslations('offer_details'),
  connect(mapStateToProps)
)(MotorbikeDetails)
